import { useMemo } from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import BeforeAfterCompare from "./BeforeAfterCompare";
import { BeforeAfterCategoryTabData } from "./types";

const BeforeAfterCategoryTabs = ({
  tabs,
  beforeLabel,
  afterLabel
}: {
  tabs?: BeforeAfterCategoryTabData[];
  beforeLabel?: string;
  afterLabel?: string;
}) => {
  const finalTabs = useMemo(() => tabs?.filter((tab) => tab.beforeImageUrl && tab.afterImageUrl), [tabs]);

  if (!finalTabs?.length) return null;

  return (
    <TabGroup className="beforeafter-categories-container w-full" defaultValue={finalTabs[0].title}>
      <TabList className="mx-auto mb-4 flex h-fit flex-nowrap justify-start gap-3 overflow-x-auto  overflow-y-hidden rounded-none border-b border-base-primary pb-2 scrollbar-hide dark:border-base-dark-primary">
        {finalTabs.map((tab) => (
          <Tab key={tab.title} value={tab.title}>
            {tab.title}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {finalTabs.map((tab) => (
          <TabPanel key={tab.title} className="mt-10 md:mt-4">
            {!!(tab.beforeImageUrl && tab.afterImageUrl) && (
              <BeforeAfterCompare
                beforeImageUrl={tab.beforeImageUrl}
                afterImageUrl={tab.afterImageUrl}
                beforeLabel={beforeLabel}
                afterLabel={afterLabel}
              />
            )}
          </TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
};
export default BeforeAfterCategoryTabs;
